import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

import Overview from "../pages/Introduction/Overview";
import SystemArchitecture from "../pages/Introduction/SystemArchitecture";
import TechStack from "../pages/Introduction/TechStack";
import WhoIsThisFor from "../pages/Introduction/WhoIsThisFor";

import Dashboard from "../pages/Core Features/Dashboard";
import EventBookingManagment from "../pages/Core Features/EventBookingManagment";
import BanquetSetup from "../pages/Core Features/BanquetSetup";
import Reports from "../pages/Core Features/Reports";
import Expense from "../pages/Core Features/Expense";
import Procurement from "../pages/Core Features/Procurement";
import Accounting from "../pages/Core Features/Accounting";
import AccessControl from "../pages/Core Features/AccessControl";
import EliminateManualRegisters from "../pages/Bussiness Solutions/EliminateManualRegisters";
import PreventDoubleBookings from "../pages/Bussiness Solutions/PreventDoubleBookings";
import RealTimeFinancialInsights from "../pages/Bussiness Solutions/RealtimeFinancialInsights";
import MultiUserAccessControl from "../pages/Bussiness Solutions/MultiUserAccessControl";
import OrganizedRecordKeeping from "../pages/Bussiness Solutions/OrganizedRecordKeeping";
import StaffEfficiency from "../pages/Bussiness Solutions/StaffEfficiency";
import Customization from "../pages/Services/Customization";
import Integration from "../pages/Services/Integration";
import DataMigration from "../pages/Services/DataMigration";
// import TrainingAndSupport from "../pages/Services/TrainingAndSupport";
import AboutUs from "../pages/Resources/AboutUs";
import Support from "../pages/Resources/Support";
import ContactUs from "../pages/Resources/ContactUs";
import FAQs from "../pages/Resources/FAQs";
import QuickStart from "../pages/Getting Started/QuickStart";
import Installation from "../pages/Getting Started/Installation";
import InitialSetup from "../pages/Getting Started/InitialSetup";
import FirstEventBooking from "../pages/Getting Started/FirstEventBooking";

/* Scroll content area to top on route change, or to section if hash present */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const el = document.getElementById("docs-content");
    
    // If there's a hash (section ID), scroll to that section
    if (hash) {
      const sectionId = hash.replace("#", "");
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      // Otherwise, scroll to top
      if (el) el.scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
}

export default function RootLayout() {
  return (
    <>
      <ScrollToTop />

      {/* NAVBAR */}
      <Navbar />

      {/* FULL DOCS AREA */}
      <div className="pt-16 h-screen bg-slate-50 overflow-hidden">
        <div className="flex h-full">

          {/* LEFT SIDEBAR */}
          <Sidebar />

          {/* CENTER + RIGHT AREA */}
          <div className="flex-1 overflow-hidden">

            <main
              id="docs-content"
              className="h-full overflow-y-auto px-10 py-8"
            >
              <Routes>

                {/* INTRO */}
                <Route path="/" element={<Overview />} />
                <Route path="/docs/overview" element={<Overview />} />
                <Route path="/docs/system-architecture" element={<SystemArchitecture />} />
                <Route path="/docs/tech-stack" element={<TechStack />} />
                <Route path="/docs/who-is-this-for" element={<WhoIsThisFor />} />

                {/* GETTING STARTED  */}
                <Route path="/docs/quick-start" element={<QuickStart />} />
                <Route path="/docs/installation" element={<Installation />} />
                <Route path="/docs/initial-setup" element={<InitialSetup />} />
                <Route path="/docs/first-event-booking" element={<FirstEventBooking />} />

                {/* CORE FEATURES */}
                <Route path="/docs/admin-dashboard" element={<Dashboard />} />
                <Route
                  path="/docs/event-booking-management"
                  element={<EventBookingManagment />}
                />
                <Route path="/docs/reports" element={<Reports />} />
                <Route path="/docs/banquet-setup" element={<BanquetSetup />} />
                <Route path="/docs/expenses" element={<Expense />} />
                <Route path="/docs/Procurement" element={<Procurement />} />
                <Route path="/docs/accounting" element={<Accounting />} />
                <Route path="/docs/access-control" element={<AccessControl />} />

                {/* Business Solutions  */}
                <Route path="/docs/no-registers" element={<EliminateManualRegisters />} />
                <Route path="/docs/no-double-booking" element={<PreventDoubleBookings />} />
                <Route path="/docs/financial-insights" element={<RealTimeFinancialInsights />} />
                <Route path="/docs/access-control-bi" element={<MultiUserAccessControl />} />
                <Route path="/docs/records" element={<OrganizedRecordKeeping />} />
                <Route path="/docs/staff-efficiency" element={<StaffEfficiency />} />

                {/* Services  */}
                <Route path="/docs/customization" element={<Customization />} />
                <Route path="//docs/integration" element={<Integration />} />
                <Route path="/docs/data-migration" element={<DataMigration />} />
                {/* <Route path="/docs/training-support" element={<TrainingAndSupport />} /> */}

                {/* Resources */}
                <Route path="/docs/about" element={<AboutUs />} />
                <Route path="/docs/support" element={<Support />} />
                <Route path="/docs/contact" element={<ContactUs />} />
                <Route path="/docs/faqs" element={<FAQs />} />

              </Routes>
            </main>

          </div>
        </div>
      </div>
    </>
  );
}
